import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as data from 'src/assets/data.json';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {
  @Input() patientId: string = ''
  public itemIndex = 0
  public isFullscreen = false
  public carouselProperties :{height: any, cellsToShow: number}= {
    height: 200,
    cellsToShow: 0
  }
  public images: Array<any> = []
  public keys: Array<any> = [];

  constructor() { }

  ngOnInit(): void {
    let similarPics :Array<any> = []
    let paths :Array<string> = []
    similarPics = data.data.find(x => x.info.Id == this.patientId)!!.similar_pics;
    this.keys = Object.keys(similarPics[0])
    for(let i = 0; i< similarPics.length; i++){
      let image: any = {}
      for(let j=0; j<this.keys.length; j++){
        if(this.keys[j]== 'name'){
          let path = '../assets/pictures/'.concat(similarPics[i].name)
          image[this.keys[j]] = path
        }
        else{
          image[this.keys[j]] = similarPics[i][this.keys[j]]
        }
      }
      this.images.push(image)
    }
  }

  ngAfterViewInit(): void{
    let carouselArrowPrevElements = document.getElementsByClassName('carousel-arrow-prev')
    let carouselArrowPrev = carouselArrowPrevElements[0] as HTMLElement
    carouselArrowPrev?.setAttribute("style", "left: 20px")
  }

  fullscreenToggled(e:any): void {
    let CarouselElements = document.getElementsByClassName('carousel')
    let CarouselElement = CarouselElements[0] as HTMLElement
    let CarouselCellsElements = document.getElementsByClassName('carousel-cells')
    let CarouselCells = CarouselCellsElements[0] as HTMLElement
    let CarouselImages = document.getElementsByClassName('my-carousel-images')
    if(e == "enter"){
      this.carouselProperties.height = "100vh"
      this.carouselProperties.cellsToShow = 1
      CarouselElement?.setAttribute("style", "height: 100vh")
      this.isFullscreen = true
      for(let i = 0; i < CarouselImages.length; i++){
        CarouselImages[i]?.setAttribute("style", "display: none")
      }
    }
    else if (e == "exit"){
      this.carouselProperties.height = 200
      this.carouselProperties.cellsToShow = 0
      this.isFullscreen = false
      for(let i = 0; i < CarouselImages.length; i++){
        CarouselImages[i]?.removeAttribute("style")
      }
    }
    CarouselCells!!.style.transform =  "translateX(0px)"
  }

  fullscreenActivated(e:any): void {
    if(e == 'active'){
        let CarouselArrowElements = document.getElementsByClassName('carousel-arrow-next')
        let CarouselArrow = CarouselArrowElements[0] as HTMLElement
        if(this.itemIndex > 0){
          this.setIntervalX(function () {
            CarouselArrow.click()
          }, 350, this.itemIndex);   
        } 
    }
  }

  setIntervalX(callback:any, delay:any, repetitions:number) {
    var x = 0;
    var intervalID = window.setInterval(function () {

       callback();

       if (++x === repetitions) {
           window.clearInterval(intervalID);
       }
    }, delay);
}

}
